import { request } from '../request';

/**
 * 获取省市二级分类
 * GET /geo/provinces
 */
export function fetchGetGeoProvinces() {
  return request<Api.Geo.GeoProvinceResponse[]>({
    url: '/geo/provinces',
    method: 'GET'
  });
}
